import { motion } from "framer-motion";
import { AREAS, AREA_ORDER } from "@/components/discovery/areas";

// "Your journey is just beginning" — personalized cards for discoveries actually surfaced.
export const JourneyPreviews = ({ previews = {}, discoveries = [], onViewed }) => {
  const items = AREA_ORDER.filter((k) => discoveries.some((d) => d.area === k))
    .map((k) => ({ key: k, a: AREAS[k], p: previews[k], d: discoveries.find((x) => x.area === k) }))
    .filter((x) => x.p || x.d?.line);
  if (!items.length) return null;

  return (
    <motion.section className="mt-16" data-testid="journey-previews" onViewportEnter={onViewed}>
      <div className="text-center">
        <p className="eyebrow text-[11px] text-teal-700">Personalized from our conversation</p>
        <h2 className="mt-3 text-[28px] font-bold leading-tight tracking-tight text-slate-900">
          Your journey is <span className="fio-gradient-text">just beginning</span>
        </h2>
      </div>
      <div className="mt-8 space-y-4">
        {items.map(({ key, a, p, d }, i) => (
          <motion.article key={key} data-testid={`journey-preview-${key}`}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="fio-glass-strong relative overflow-hidden rounded-[28px] p-6"
            style={{ boxShadow: `0 0 0 1px ${a.color}26, 0 18px 50px -24px ${a.glow}` }}>
            <span aria-hidden className="absolute -right-10 -top-10 h-36 w-36 rounded-full blur-3xl" style={{ background: a.glow, opacity: 0.3 }} />
            <div className="relative flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-2xl text-white" style={{ background: `linear-gradient(135deg, ${a.color}, #6D5BD0)` }}>
                  <a.Icon className="h-5 w-5" strokeWidth={2} />
                </span>
                <p className="eyebrow text-[10px] font-semibold" style={{ color: a.color }}>Your {a.label}</p>
              </div>
              <span className="flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-medium" style={{ background: a.tint, color: a.color }}>
                <span className="h-1.5 w-1.5 rounded-full fio-pulse-dot" style={{ background: a.color }} /> Ready to explore
              </span>
            </div>
            <h3 className="relative mt-4 text-xl font-bold leading-snug tracking-tight text-slate-900">{p?.title || a.headline}</h3>
            <p className="relative mt-2 text-[15px] leading-relaxed text-slate-700">{p?.detail || d?.line}</p>
            <p className="relative mt-4 text-xs text-slate-500">{a.explore}</p>
          </motion.article>
        ))}
      </div>
    </motion.section>
  );
};
